module.exports = __webpack_public_path__ + "img/statement.bf11d352.svg";